import { render, staticRenderFns } from "./RegionThresholdEditWindow.vue?vue&type=template&id=29d5796b&scoped=true"
import script from "./RegionThresholdEditWindow.vue?vue&type=script&lang=js"
export * from "./RegionThresholdEditWindow.vue?vue&type=script&lang=js"
import style0 from "./RegionThresholdEditWindow.vue?vue&type=style&index=0&id=29d5796b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d5796b",
  null
  
)

export default component.exports